import { Component, OnInit, Input } from '@angular/core';
import { UtilService, VariablesService, FundraiserService, StorageService } from '../../../../shared/services';
import { IOrder } from '../../../payment/models/order.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-thankyou-banner',
  templateUrl: './thankyou-banner.component.html',
  styleUrls: ['./thankyou-banner.component.scss']
})
export class ThankyouBannerComponent implements OnInit {

  @Input() isDonated;
  @Input() donations;
  @Input() fundraiser;
  donor;
  basicInfo;
  campaingUrl;
  userData;
  showBanner;
  status;
  isAskedForUpdate;
  constructor(
    public utilService: UtilService,
    public variablesService: VariablesService,
    public fundraiserService: FundraiserService,
    private actRoute: ActivatedRoute,
    public storageService: StorageService,
    public router: Router
  ) { }

  ngOnInit() {
    this.campaingUrl = this.utilService.domain_details.full_url;
    this.setBasicInfo(this.fundraiser?.basicinfo);
    this.variablesService.userData.subscribe({
      next: (res) => {
        this.userData = res;
      }
    });
    this.showBanner = this.storageService.getFromSession('showBanner');
    if (this.showBanner && this.actRoute.snapshot.queryParams['oi'] && !this.actRoute.snapshot.queryParams['st']) {
      this.getOrderDetails(this.fundraiser?.id, this.actRoute.snapshot.queryParams['oi']);
    }
    this.variablesService.showThankYoubanner.subscribe({
      next: (res) => {
        if (res) {
          this.showBanner = true;
          this.isDonated = true;
          this.getOrderDetails(this.fundraiser?.id, res);
        }
      }
    });
  }
  /**Set Basic Info */
  setBasicInfo(data: any[]) {
    this.basicInfo = {};
    if (data && data.length) {
      for (const item of data) {
        this.basicInfo[item.info_type] = item.info_1;
      }
    }
  }
  ifAskedForUpdate(data) {
    this.isAskedForUpdate = data;
  }
  /**send the click event to child component */
  askUpdateClickListner(_el: any) {
    if (_el.children[0]) {
      _el.children[0].children[0].click();
    }
  }

  /**Get the details of the order from order id
   * recieved from the params
   */
  getOrderDetails(campaignId, orderId) {
    const qPrams = '?with=campaign.campaigner.avtar&search=transaction_return_status:200';
    this.fundraiserService.getOrderDetails(campaignId, orderId, qPrams).subscribe((res: any) => {
      this.donor = res.data.order;
      this.status = this.donor.is_anonymous;
    });
  }
  /**Set user anonymous */
  updateAnonymousStatus() {
    const payload = {
      is_anonymous: this.status === 1 ? 0 : 1
    };
    this.fundraiserService.updateAnonymous(payload, this.userData.id, this.donor.order_id).subscribe((res: any) => {
      this.status = +res.data.is_anonymous;
    });
  }

}
